// Header.js
import React, { useEffect, useState } from 'react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <div className="logo">
          <h1>YU HSIEN LIN</h1>
        </div>
        <nav className="navigation">
          <ul>
            <li><a href="#about">關於我</a></li>
            <li><a href="#portfolio">作品集</a></li>
            <li><a href="#contact">聯絡方式</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;